<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('emailTemplate.title') }}
    v-row(v-if="attachReport")
      v-col(cols="9")
        app-simple-entity-search(
          :value="instance.reportSelected",
          :entity="reportEntity",
          @input="setReport",
        )
      v-col(cols="3")
        v-select.mt-4(
          :items="[PDF, DOCX]",
          v-model="instance.format",
          :label="$t('emailTemplate.selectFormat')"
        )
    v-row
      v-col(cols="12")
        v-switch(
          :label="$t('emailTemplate.showPendingTask')"
          v-model="instance.pendingTask"
        )
      v-col(cols="12")
        v-text-field(
          :label="$t('emailTemplate.subject')"
          v-model="instance.subject"
        )
      v-col(cols="6")
        v-text-field(
          :label="$t('emailTemplate.from')"
          :rules="emailRules",
          v-model="instance.from"
        )
      v-col(cols="6")
        v-text-field(
          @keydown.enter="pushEmailAndClear('to', $event)",
          :rules="emailRules",
          :label="$t('emailTemplate.to')"
        )
        v-chip(v-for="(t, i) in instance.to", close, @click:close="instance.to.splice(i, 1)")
          span(class="text-size") {{ t }}
      v-col(cols="6")
        v-text-field(
          @keydown.enter="pushEmailAndClear('cc', $event)",
          :rules="emailRules",
          :label="$t('emailTemplate.cc')"
        )
        v-chip(v-for="(t, i) in instance.cc", close, @click:close="instance.cc.splice(i, 1)")
          span(class="text-size") {{ t }}
      v-col(cols="6")
        v-text-field(
          @keydown.enter="pushEmailAndClear('bcc', $event)",
          :rules="emailRules",
          :label="$t('emailTemplate.bcc')"
        )
        v-chip(v-for="(t, i) in instance.bcc", close, @click:close="instance.bcc.splice(i, 1)")
          span(class="text-size") {{ t }}
      v-col(cols="12")
        v-text-field(
          :label="$t('emailTemplate.quoteType')"
          v-model="instance.quoteType"
        )
      v-col(cols="12")
        h5.caption {{ $t('emailTemplate.pressAdd') }}
    code-editor(
      v-model="instance.body",
      language="htmlembedded"
    )
    v-row
      v-col(cols="12")
        document-request-selector(
          v-model="instance.attachments",
          :currentValues="instance.attachments",
          :multiple="true",
        )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>
import { PDF, DOCX, emailPattern } from '@/components/ActionTemplate/constants.js';
import DocumentRequestSelector from '@/components/ActionTemplate/DocumentRequestSelector';

export default {
  props: ['value', 'attachReport'],
  components: { DocumentRequestSelector },
  data: function ()  {
    return {
      initialObject: {
        attachments: [],
        reportSelected: null,
        type: 'Send Email',
        to: [],
        subject: '',
        from: '',
        cc: [],
        bcc: [],
        quoteType: '',
        markdown: null,
        body: '',
        entityId: '@Model.Id',
        isRazor: true,
        pendingTask: false, 
      },
      instance: {},

      // show on render
      PDF,
      DOCX,
      emailPattern,
    }
  },
  computed: {
    emailRules () {
      return [
        v => !v || this.emailPattern.test(v) || this.$t('emailTemplate.validEmail')
      ];
    },
    reportEntity() {
      return this.$findEntity("Report");
    },
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    pushEmailAndClear (prop, event) {
      if (this.emailPattern.test(event.target.value)) {
        this.instance[prop].push(event.target.value);
        event.target.value = null; // clear text field
      }
    },
    setReport(e) {
      this.instance.report_uid = e.uid
    },
  },
  created() {
    this.instance = { ...this.initialObject, ...this.value };
  },
}
</script>
